import { defineMessages } from "react-intl";

export default defineMessages({
  title: {
    id: "FuelingProcessCancelEdit.title",
    defaultMessage: "Manual fueling process canceling",
  },
  description: {
    id: "FuelingProcessCancelEdit.description",
    defaultMessage: "Description",
  },
  descriptionHint: {
    id: "FuelingProcessCancelEdit.descriptionHint",
    defaultMessage: "Reason",
  },
  cancelProcess: {
    id: "FuelingProcessCancelEdit.cancelProcess",
    defaultMessage: "Cancel process",
  },
  canceling: {
    id: "FuelingProcessCancelEdit.saving",
    defaultMessage: "Canceling",
  },
  close: {
    id: "FuelingProcessCancelEdit.close",
    defaultMessage: "Close",
  },
  eventualUpdateDescription: {
    id: "FuelingProcessCancelEdit.eventualUpdateDescription",
    defaultMessage:
      "After canceling please wait some time and update table to see changes.",
  },
  errorCodeRejected: {
    id: "FuelingProcessCancelEdit.errorCodeRejected",
    defaultMessage: "Rejected",
  },
  errorCodeUnacceptableStateTransition: {
    id: "FuelingProcessCancelEdit.unacceptableStateTransition",
    defaultMessage: "Unacceptable state transition",
  },
  errorCodeError: {
    id: "FuelingProcessCancelEdit.errorCodeError",
    defaultMessage: "Error",
  },
  cancelConfirm: {
    id: "FuelingProcessCancelEdit.cancelConfirm",
    defaultMessage: "Are you sure you want to cancel this fueling process?",
  },
});
